import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BlobType, RequestExtensionPayload } from '@ca/core/models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SUPPORTED_IMAGE_TYPES } from 'src/app/shared/constants/form-validators';
import { FilesUploadButtonComponent } from '../../../../shared/components/files-upload-button/files-upload-button.component';

@Component({
    selector: 'ca-extend-trial-dialog',
    templateUrl: './extend-trial-dialog.component.html',
    styleUrls: ['./extend-trial-dialog.component.scss'],
})
export class ExtendTrialDialogComponent {
    @ViewChild(FilesUploadButtonComponent) uploadComponent: FilesUploadButtonComponent;
    @Input() isBiotechUser: boolean = false;
    @Input() isAcademiaTrial: boolean;
    @Input() pathToAppend: string;
    @Output() onSubmit = new EventEmitter<RequestExtensionPayload>();

    readonly blobType = BlobType;
    SUPPORTED_FILE_TYPES = [...SUPPORTED_IMAGE_TYPES, 'pdf'];

    constructor(private activeModal: NgbActiveModal) {}

    private buildPayload(): RequestExtensionPayload {
        return {
            fileUri: this.uploadComponent?.fileUrls?.value[0],
        };
    }
    close(): void {
        this.activeModal.close();
    }
    submit(): void {
        const payload: RequestExtensionPayload = this.buildPayload();
        this.onSubmit.next(payload);
        this.activeModal.close();
    }
}
